<template>
  <div class="products-each">
    <!-- 左边列表 -->
    <div class="sku-left">
      <div class="product-double" v-for="(sku, index) in leftList" :key="index + 'left'">
        <a
          href="javascript:;"
          class="product-intro"
          @click="jumpDetails(sku.item_id, sku.sku_id, sku.platform, sku.item_type)"
        >
          <div class="sku-img">
            <img v-lazy="sku.pic_url" />
          </div>
          <div class="sku-intro">
            <div class="sku-name" v-if="sku.platform_info">
              <sku-platform :platform="sku.platform_info"></sku-platform>
              {{sku.name}}
            </div>
             <div class="sku-price">
              <div class="buy-price">购买价: {{sku.equity.discount}}</div>
              <div class="normal-price">原价: {{sku.market_price}}</div>
            </div>
          </div>
          <!-- <div class="tips">0元购</div> -->
          <div class="tips">{{sku.equity.discount | diffPrice(sku.market_price)}}</div>
        </a>

      </div>
    </div>
    <!-- 右边列表 -->
    <div class="sku-right">
      <div class="product-double" v-for="(sku, index) in rightList" :key="index + 'right'">
        <a
          href="javascript:;"
          class="product-intro"
          @click="jumpDetails(sku.item_id, sku.sku_id, sku.platform, sku.item_type)"
        >
          <div class="sku-img">
            <img v-lazy="sku.pic_url" />
          </div>
          <div class="sku-intro">
            <div class="sku-name" v-if="sku.platform_info">
              <sku-platform :platform="sku.platform_info"></sku-platform>
              {{sku.name}}
            </div>
            <div class="sku-price">
              <div class="buy-price">购买价: {{sku.equity.discount}}</div>
              <div class="normal-price">原价: {{sku.market_price}}</div>
            </div>
          </div>
          <!-- <div class="tips" v-if="!sku.equity.discount">0元购</div> -->
          <div class="tips">{{sku.equity.discount | diffPrice(sku.market_price)}}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SkuPlatform from '../SkuPlatform'
import api from '../../utils/api'
import Big from 'big.js'
const init = new Big(0)
let flag = false
export default {
  name: 'productDoubleEach',
  props: {
    skuList: {
      type: Array,
      require: true
    },
    column: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    SkuPlatform
  },
  filters: {
    diffPrice (discountPrice, normalPrice) {
      if (discountPrice * 1) {
        return `直降${init.plus(normalPrice).minus(discountPrice).toFixed(2)}`
      } else {
        return '0元购'
      }
    }
  },
  computed: {
    leftList () {
      return this.skuList && this.skuList.length
        ? this.skuList.filter((v, i) => (i + 1) % 2 !== 0)
        : []
    },
    rightList () {
      return this.skuList.filter((v, i) => (i + 1) % 2 === 0)
    }
  },
  methods: {
    /**
     * 跳转商品详情
     * @param(String) id  商品skuid
     * @param(String) paltform 平台标识
     */
    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.hornorBuyRouteJump({ aid: this.column, goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.products-each{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sku-left,
.sku-right {
  display: flex;
  flex-direction: column;
}
.product-double {
  margin-bottom: 0.2rem;
  width: 3.45rem;
  background-color: #fff;
  border-radius: 0.08rem;
  overflow: hidden;
  position: relative;
  .product-intro {
    color: @base;
  }
  .sku-img {
    width: 100%;
    height: 3.45rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .sku-intro {
    padding: 0.1rem 0.1rem 0.2rem;
    .sku-name {
      font-size: @fz24;
      .ellipsis2;
    }
    .sku-tips {
      margin-bottom: 0.18rem;
    }
  }
  .sku-price {
    padding-top: 0.2rem;
    font-size: @fz22;
    .buy-price {
      color: #FF3824;
    }
    .normal-price {
      color: @base;
      padding-top: 0.12rem;
    }
  }
  .tips {
    position: absolute;
    right: 0.2rem;
    bottom: 0.2rem;
    min-width: 0.6rem;
    height: 0.38rem;
    padding: 0 0.15rem;
    border-radius: 30px;
    background-color: #FFEAEF;
    color: #FF3824;
    font-size: @fz22;
    .flex-center;
  }
}
</style>
